export default {
  title: 'Kuukausittaiset tiliotteet',
  list: {
    empty_list: {
      title: 'Ei vielä kuukausittaisia tiliotteita.',
    },
    fields: {
      month: 'Kuukausi',
      stripe_service_invoice_url: 'Stripe-lasku',
      paypal_service_invoice_url: 'PayPal-lasku',
    },
    button: {
      title: 'Vie',
    },
  },
  export_modal: {
    title: 'Vie',
    start_date: {
      title: 'Alkamispäivä',
      placeholder: 'päivämäärä',
    },
    end_date: {
      title: 'Päättymispäivä',
      placeholder: 'päivämäärä',
    },
    button: {
      export: 'Vie',
      close: 'Sulje',
    },
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataus epäonnistui',
  },
};
